// db.js
import { openDB } from "idb";

// Define schema types for TypeScript-like safety
const DB_NAME = "jobDB";
const DB_VERSION = 2;

// Cached connection
let dbInstance = null;

// Object store names
export const STORES = {
  JOBS: "jobs",
  FILTERGROUPS: "filterGroups",
};

// export const initDB = () => {
//   return openDB("jobDB", 2, {
//     upgrade(db) {
//       if (!db.objectStoreNames.contains("jobs")) {
//         db.createObjectStore("jobs", { keyPath: "id" });
//       }
//       if (!db.objectStoreNames.contains("filterGroups")) {
//         db.createObjectStore("filterGroups", { keyPath: "tableId" });
//       }
//     },
//   });
// };

export const initDB = async () => {
  // Return cached connection if available
  if (dbInstance) {
    return dbInstance;
  }

  try {
    dbInstance = await openDB(DB_NAME, DB_VERSION, {
      upgrade(db, oldVersion, newVersion, transaction) {
        // Handle migrations based on version
        if (oldVersion < 1) {
          // Initial schema creation
          const jobsStore = db.createObjectStore("jobs", { keyPath: "id" });
          jobsStore.createIndex("status", "status", { unique: false });
          jobsStore.createIndex("date", "date", { unique: false });

          db.createObjectStore("filterGroups", { keyPath: "tableId" });
        }

        if (oldVersion < 2) {
          // Migration from v1 to v2
          // Add new indexes, modify stores, etc.
          const jobsStore = transaction.objectStore("jobs");
          if (!jobsStore.indexNames.contains("status")) {
            jobsStore.createIndex("status", "status", { unique: false });
          }
        }
      },

      blocked() {
        // Handle blocked upgrades (another tab has older version)
        console.warn("Database upgrade blocked by another tab");
      },

      blocking() {
        // Close connection to allow upgrade in other tab
        dbInstance?.close();
        dbInstance = null;
      },
    });

    // Handle connection errors
    dbInstance.onerror = (event) => {
      console.error("IndexedDB error:", event);
      dbInstance = null;
    };

    return dbInstance;
  } catch (error) {
    console.error("Failed to initialize IndexedDB:", error);
    dbInstance = null;
    throw error;
  }
};

// Helper to close connection (useful for testing/cleanup)
export const closeDB = async () => {
  if (dbInstance) {
    dbInstance.close();
    dbInstance = null;
  }
};
